// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vjND","col":"styles_col__3E2gC","actions":"styles_actions__1m4u7","conflict":"styles_conflict__A1Ajh"};